import { LazyRoute } from '@app/components/lazy-route';
import { PusherProviderWrapper } from '@app/components/pusher-provider';
import React, { lazy } from 'react';

const Libary = lazy(() => import('./library-page'));

const Library = () => {
  return (
    <LazyRoute>
      <PusherProviderWrapper>
        <Libary />
      </PusherProviderWrapper>
    </LazyRoute>
  );
};

export { Library };
